import f from "moment";
import m from "../time/getTimeSpanParts.mjs";
import c from "../date/getTimezoneUtcOffsetDifference.mjs";
import a from "../date/convertToSpecificTimezone.mjs";
import l from "./getServiceIntervalTimeSpanMoment.mjs";
function v(o, i, r) {
  const n = m(i.duration);
  let e = l(
    o,
    i.from
  ), t = e.clone().add(n);
  return c(
    e,
    t
  ) && (e = a(
    e,
    r ?? f().utcOffset(),
    !0
  ), t = e.clone().add(n)), {
    openingTime: e,
    closingTime: t
  };
}
export {
  v as default
};
